import React, { useCallback, useEffect, useState } from 'react'
import _cx from 'classnames/bind'
import PropTypes from 'prop-types'
import { ListingBadges, hooks } from '@adc/ui-adc'
import { NOTIFY_RESERVE } from '../../statics'
import cls from './index.scss'

const cx = _cx.bind(cls)
const { useIsMobileHook } = hooks

const Badges = ({ listing, badgeActions }) => {
  const [badgesPerRow, setBadgesPerRow] = useState(null)
  const badgeEventSubscriber = useCallback(
    (ref, e) => {
      if (ref === 'contact_agent' || ref === 'interior_access_contact_agent') {
        badgeActions.toggleContactModal()
      }

      if (ref === 'notify_me') {
        badgeActions.toggleSaveProperty({
          source: NOTIFY_RESERVE,
        })
      }
    },
    [badgeActions]
  )
  const isMobile = useIsMobileHook()

  useEffect(() => {
    setBadgesPerRow(isMobile ? 1 : 2)
  }, [isMobile])

  return (
    <div className={cx('badge-list')}>
      {badgesPerRow ? (
        <ListingBadges
          listing={listing}
          eventSubscriber={badgeEventSubscriber}
          badgesPerRow={badgesPerRow}
        />
      ) : null}
    </div>
  )
}

Badges.propTypes = {
  listing: PropTypes.object.isRequired,
  badgeActions: PropTypes.object.isRequired,
}

export default Badges
